<template>
  <div class="editable-input">
    <i-input ref="input" :value="value" v-on="$listeners" @keyup.native.enter="$emit('on-save')" />
    <i-button-group>
      <i-button type="primary" icon="md-checkmark" :loading="loading" @click="$emit('on-save')" />
      <i-button type="default" icon="md-close" @click="$emit('on-cancel')" />
    </i-button-group>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String],
        default: ''
      },

      loading: {
        type: Boolean,
        default: false
      }
    },
    created() {
      document.addEventListener('keyup', this.on_keyup);
    },

    mounted() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },

    destroyed() {
      document.removeEventListener('keyup', this.on_keyup);
    },

    methods: {
      on_keyup: function(evt) {
        if (evt.key === 'Escape') {
          this.$emit('on-cancel');
        }
      }
    }
  };
</script>

<style lang="scss">
  .editable-input {
    display: flex;
    flex-wrap: nowrap;

    .ivu-input-wrapper {
      width: auto;
    }

    .ivu-btn-group {
      margin-left: 15px;
      display: flex;
    }
  }
</style>
